import { gql } from '@apollo/client';

const existingCampaign = gql`
  fragment TcrCampaignFragment on TcrCampaign {
    ageGated
    autoRenewal
    billedDate
    brandId
    campaignId
    createDate
    cspId
    description
    directLending
    embeddedLink
    embeddedPhone
    helpKeywords
    helpMessage
    messageFlow
    mock
    nextRenewalOrExpirationDate
    numberPool
    optinKeywords
    optinMessage
    optoutKeywords
    optoutMessage
    referenceId
    resellerId
    sample1
    sample2
    sample3
    sample4
    sample5
    status
    subUsecases
    subscriberHelp
    subscriberOptin
    subscriberOptout
    termsAndConditions
    usecase
  }
`;
export const CreateTcrCampaignViewQuery = gql`
  ${existingCampaign}
  query CreateTcrCampaignView($campaignId: ID!, $internalCampaignId: String!) {
    campaign(id: $campaignId) {
      id
      agentName
      brand {
        company {
          id
          name
        }
      }
      schedulerFlow {
        generator {
          replacements
        }
      }
      dataForTcrCampaignCreation {
        sample1
        sample2
      }
    }
    tcrDataForTcrCampaignCreation(internalCampaignId: $internalCampaignId) {
      mnos {
        displayName
        networkId
      }
      existingCampaign {
        ...TcrCampaignFragment
      }
      sharing {
        explanation
        sharingStatus
        upstreamCnpId
      }
    }
  }
`;

export const CreateTcrCampaignMutation = gql`
  mutation CreateTcrCampaign(
    $campaignId: String!
    $input: CreateTcrCampaignInput!
    $editableFields: UpdateTcrCampaignInput!
  ) {
    createTcrCampaign(campaignId: $campaignId, input: $input, editableFields: $editableFields) {
      campaignId
      sharingStatus
    }
  }
`;

export const UpdateTcrCampaignMutation = gql`
  ${existingCampaign}
  mutation UpdateTcrCampaign($tcrCampaignId: String!, $editableFields: UpdateTcrCampaignInput!) {
    updateTcrCampaign(tcrCampaignId: $tcrCampaignId, editableFields: $editableFields) {
      ...TcrCampaignFragment
    }
  }
`;
